import React from "react";
import { Layout } from "@/components/Layout";
import { PageHero } from "@/components/PageHero";

export default function Privacy() {
  return (
    <Layout hideRightPanel>
      <PageHero
        testId="privacy-hero"
        eyebrow="Legal"
        title="Privacy Policy"
        sub="Short version: we collect the minimum we need to run the product, we never sell your data, and you can delete your account at any time."
      />
      <article className="prose prose-sm max-w-none text-[#0B1220] space-y-6 text-[14px] leading-relaxed" data-testid="privacy-body">
        <section>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">What we collect</h2>
          <ul className="text-[#5B6478] space-y-1.5 list-disc pl-5">
            <li><strong className="text-[#0B1220]">Account:</strong> email, name, and profile picture from Google Sign-In.</li>
            <li><strong className="text-[#0B1220]">Usage:</strong> anonymized page views and click events to improve the product.</li>
            <li><strong className="text-[#0B1220]">Content you create:</strong> favorites, stack pins, and Wikifi conversations, stored so you can pick up where you left off.</li>
            <li><strong className="text-[#0B1220]">Payments:</strong> handled by Stripe. We never see your card number.</li>
          </ul>
        </section>
        <section>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">What we don't do</h2>
          <ul className="text-[#5B6478] space-y-1.5 list-disc pl-5">
            <li>Sell, rent, or trade your data.</li>
            <li>Serve targeted ads on Wikificial.</li>
            <li>Read your Wikifi conversations to train our own models.</li>
          </ul>
        </section>
        <section>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">Third-party AI providers</h2>
          <p className="text-[#5B6478]">
            When you use Wikifi, your prompt is forwarded to the model you
            picked (OpenAI, Anthropic, Google, xAI, or Perplexity). Each
            provider has its own retention policy — links in the sub-provider
            list at contact@wikifi.app on request.
          </p>
        </section>
        <section>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">Cookies</h2>
          <p className="text-[#5B6478]">
            We use one first-party cookie to keep you signed in
            (<code className="text-[13px] bg-[#F7F8FA] px-1.5 py-0.5 rounded border border-[#E7EAF0]">session_token</code>).
            No third-party ad cookies.
          </p>
        </section>
        <section>
          <h2 className="font-display text-lg font-bold text-[#0B1220] mb-2 tracking-tight">Your rights</h2>
          <p className="text-[#5B6478]">
            Export or delete your data anytime by emailing contact@wikifi.app.
            Deletion is permanent and takes effect within 30 days.
          </p>
        </section>
        <div className="text-[11px] text-[#8A93A6] pt-4">Last updated: February 2026.</div>
      </article>
    </Layout>
  );
}
